import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFullscreen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.677 18.992-2.673.005a1 1 0 0 1-1.002-1.002l.006-2.672M5.498 18.5l3.504-3.504M6.01 9.679l-.006-2.673a1 1 0 0 1 1.002-1.002l2.673.006M17.991 14.324l.006 2.673a1 1 0 0 1-1.002 1.002l-2.673-.006M15.32 5.01l2.674-.006a1 1 0 0 1 1.002 1.002l-.007 2.672M18.5 5.5l-3.504 3.504"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFullscreen);
export default ForwardRef;
